import { render, staticRenderFns } from "./CompositionPayment.vue?vue&type=template&id=167987c8&"
import script from "./CompositionPayment.vue?vue&type=script&lang=js&"
export * from "./CompositionPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports